import { EmployeeAlertPriority } from '@/common/graphql';

export const EmployeeAlertPriorityLabels: Record<EmployeeAlertPriority, string> = {
  [EmployeeAlertPriority.High]: 'High',
  [EmployeeAlertPriority.Medium]: 'Medium',
  [EmployeeAlertPriority.Low]: 'Low',
};
